import CancelButton from "@common/controls/Form/Buttons/Cancel";
import SubmitButton from "@common/controls/Form/Buttons/Submit";
import { FormButtons, FormField } from "@common/controls/Form/component";
import Select from "@common/controls/Inputs/Select/component";
import { FormModalControlled, type FormModalControlledRenderParams } from "@common/controls/Modal/Modals/Form/component";
import withShow, { type WithShowProps } from "@common/controls/Modal/Modals/hocs/withShow";
import withSubmit, { type WithSubmitProps } from "@common/controls/Modal/Modals/hocs/withSubmit";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type AccountOptionItem, getDefaultDateValue, getMonthOptions } from "./lib";

export type StatementModalFormData = {
  accountId: string;
  date: Date;
};

type StatementModalProps = WithSubmitProps<StatementModalFormData> &
  WithShowProps & {
    accountId: string;
    accountOptions: AccountOptionItem[];
  };
const StatementModal = ({ accountId, accountOptions, ...props }: StatementModalProps) => {
  const i18n = useI18n();

  const defaultValues = React.useMemo(
    (): Partial<StatementModalFormData> => ({
      accountId,
      date: getDefaultDateValue(i18n, accountOptions, accountId)
    }),
    [accountId, i18n]
  );

  return (
    <FormModalControlled {...props} title={i18n.downloadStatement} defaultValues={defaultValues}>
      {({ onChange, values }: FormModalControlledRenderParams<StatementModalFormData>) => (
        <>
          {accountOptions.length > 1 && (
            <FormField
              Component={Select}
              componentProps={{
                options: accountOptions.map((x) => ({ label: x.label, value: x.value.accountId }))
              }}
              isRequired
              label={i18n.account}
              onChange={(_, value) => {
                onChange("accountId", value);

                onChange("date", getDefaultDateValue(i18n, accountOptions, value));
              }}
              name="accountId"
              value={values.accountId}
            />
          )}

          <FormField
            Component={Select}
            componentProps={{
              options: getMonthOptions(i18n, accountOptions, values.accountId)
            }}
            isRequired
            label={i18n.month}
            name="date"
            value={values.date}
          />

          <FormButtons>
            <CancelButton />
            <SubmitButton label={i18n.download} />
          </FormButtons>
        </>
      )}
    </FormModalControlled>
  );
};

const StatementModalWithShowSubmit = withShow(withSubmit(StatementModal));
export default StatementModalWithShowSubmit;
